/**
 * PixoryAI Backend Configuration
 *
 * Central source of truth for all backend endpoint URLs.
 * All frontend modules should import from here instead of hardcoding URLs.
 *
 * Env variable:
 *   VITE_VPS_BACKEND_URL=https://pixoryai.com
 */

export const VPS_BACKEND_URL =
  import.meta.env.VITE_VPS_BACKEND_URL || "https://pixoryai.com";

export const VPS_UPLOAD_ENDPOINT = `${VPS_BACKEND_URL}/upload.php`;
export const VPS_DELETE_ENDPOINT = `${VPS_BACKEND_URL}/delete.php`;
export const VPS_HEALTH_ENDPOINT = `${VPS_BACKEND_URL}/api/health.php`;

/** Legacy edge-function endpoints — kept for reference but prefer VPS direct for production */
export const VPS_UPLOAD_PROXY = `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/vps-upload-proxy`;
export const VPS_DELETE_PROXY = `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/vps-delete-proxy`;